import { Space } from "antd";
import classNames from "classnames";
import { get } from "lodash";
import { BiPlus, BiTrash } from "react-icons/bi";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import { COLORS } from "shared/style/colors";
import {
  formatFrozenValue,
  mergeMappingRow,
  parseFrozenValue,
} from "./connectorMapping";

const MappingList = ({
  value,
  leftKey,
  rightKey,
  leftLabel,
  rightLabel,
  valueLabel,
  valueHint,
  addLabel,
  onChange,
}) => {
  const rows = value || [];
  const showFrozenValue = Boolean(valueLabel);

  const update = (index, patch) =>
    onChange(
      rows.map((row, i) => (i === index ? mergeMappingRow(row, patch) : row)),
    );

  const remove = (index) => onChange(rows.filter((_, i) => i !== index));

  const add = () => onChange([...rows, { [leftKey]: "", [rightKey]: "" }]);

  return (
    <Space direction="vertical" size={6} className="canvas-editor__full-width">
      {rows.map((row, index) => (
        <div
          key={index}
          className={classNames("canvas-editor__list-row", {
            "canvas-editor__list-row--triple": showFrozenValue,
          })}
        >
          <Input
            placeholder={leftLabel}
            value={get(row, leftKey, "")}
            onChange={(e) => update(index, { [leftKey]: e.target.value })}
          />
          <Input
            placeholder={rightLabel}
            value={get(row, rightKey, "")}
            onChange={(e) => update(index, { [rightKey]: e.target.value })}
          />
          {showFrozenValue ? (
            <Input
              placeholder={valueLabel}
              value={formatFrozenValue(get(row, "value"))}
              onChange={(e) =>
                update(index, { value: parseFrozenValue(e.target.value) })
              }
            />
          ) : null}
          <div className="delete-icon" onClick={() => remove(index)}>
            <BiTrash color={COLORS.C_DANGER} size={16} />
          </div>
        </div>
      ))}
      {showFrozenValue && valueHint ? (
        <div className="canvas-editor__meta-xs">{valueHint}</div>
      ) : null}
      <Button type="primary--outlined" onClick={add}>
        <BiPlus size={16} /> {addLabel}
      </Button>
    </Space>
  );
};

export default MappingList;
